export const FETCH_NAVIGATION_DATA = 'FETCH_NAVIGATION_DATA';
